import React from 'react';
import { render } from 'react-dom';
import { App } from './App';
import './index.scss';
import 'regenerator-runtime/runtime';

const rootElement = document.getElementById('root');
render(<App />, rootElement);
